stimulusApp.register(
  "morph-keep",
  class extends Stimulus.Controller {
    static values = { attributes: String }

    keep(event) {
      if (this.#owned(event)) event.preventDefault()
    }

    // Dropping the attribute is the server's own state change: a filter row
    // whose parent was unchecked loses `data-open`, so a later re-check starts
    // from the server default again.
    keepUnlessDropped(event) {
      if (event.detail.mutationType !== "remove" && this.#owned(event))
        event.preventDefault()
    }

    #owned(event) {
      return (
        event.target === this.element &&
        this.attributesValue.split(" ").includes(event.detail.attributeName)
      )
    }
  },
)
